import * as React from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import {Helmet} from "react-helmet";

import Loading from '../../core/Loading';

function News(props) {
    const { post, tags, cat, comments } = props;
    const [categories, setCat] = React.useState([]);
    React.useEffect(() => {
      let c = cat.split(", ");
        setCat(c);
    }, [])
  return (<>
    <Helmet>
        <meta charSet="utf-8" />        
        <title>{post.title}</title>
        <meta name="title" content={`${post.title}`} />
        <meta name="robots" content="all, index, follow" />
        <meta name="description" content={post.body.substring(0, 162)} />
        <meta name="keywords" content={`${post.title}, ${cat}, ${tags}, realLexi, real lexi, real, word, ddkits, blog, post, news, posts, blog`} />
        <meta name="author" content={`${post.author.firstname} ${post.author.lastname}`} />
        <link rel="canonical" href={window.location.href} />
        <meta property="og:title" content={`${post.title}`} />
        <meta property="og:image" content={`/${post.image}`} />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:sitename" content={`${post.title}`} />
        <meta property="og:description" content={post.body.substring(0, 162)} />
        <meta name="twitter:title" content={`${post.title}`} />
        <meta name="twitter:image" content={`/${post.image}`} />
        <meta name="twitter:url" content={window.location.href} />
        <meta name="twitter:card" content={post.body.substring(0, 162)} />
          <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "Blog",
            "url": "${window.location.href}",
            "name": "${post.title}",
            "author": {
              "@type": "person",
              "name": "${post.author.firstname} ${post.author.lastname}"
            },
            "description": "${post.body.substring(0, 162)}",
            "datePublished": "${new Date(post.created_at || '').toLocaleDateString()}"
          }`} 
        </script>
    </Helmet>
    <Grid
      item
      xs={12}
      md={12}
    >
    <Paper
      sx={{
        position: 'relative',
        backgroundColor: 'grey.800',
        color: '#fff',
        mb: 5,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        minHeight: '400px',
        backgroundImage: `url("/${post.image}")`,
        boxShadow: "0px 4px 4px 0px #00000030,inset 0 0 0 1000px rgba(0,0,0,.5)"
      }}
    >
      {/* Increase the priority of the hero background image */}
      {<img style={{ display: 'none' }} src={`/${post.image}`} alt={post.imageText} />}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: 'rgba(0,0,0,.3)',
        }}
      />
      <Grid container>
        <Grid item md={12}>
          <Box
            sx={{
              position: 'relative',
              p: { xs: 3, md: 6 },
              pr: { md: 0 },
            }}
            align="center"
          >
            <Typography component="h1" variant="h3" color="inherit" gutterBottom>
              {post.title}
            </Typography>
            <Typography component="h3" variant="h5" color="inherit" gutterBottom >
              By: {post.author.title} - {new Date(post.created_at || '').toLocaleDateString()}
            </Typography>
           
          </Box>
        </Grid>
        
      </Grid>
    </Paper>

    <Divider />
            
        <Typography >
            <span dangerouslySetInnerHTML={{__html: post.body}} />
            </Typography>
            <Typography >
            <Link to={`//${post.guid}`}> Source: {post.author.title}</Link>
            </Typography>
            <Divider />
            <Typography  color="inherit" className="m-2" gutterBottom style={{ marginTop: '20px' }}>
              {categories?.length > 0 && categories?.map((x,xds) => {
                return <button className='btn btn-sx  m-2 xs' key={xds} onClick={() => window.location.href =`/search?categories=${x}`}>{x}</button>
                })}
            </Typography>
      </Grid>
    </>);
}

// Page.propTypes = {
//   post: PropTypes.arrayOf(PropTypes.string).isRequired
// };

export default News;
